import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';

import { Text } from '@/components/ui/text';
import { reviewDesk } from '@/design-system';
import { formatDate, planDisplayName } from '../profileFormat';
import { profileWebStyles } from '../profileStyles';
import type { Translate, UserProfile } from '../profileTypes';

interface SubscriptionNoticeBannersProps {
  profile: UserProfile;
  shouldResubscribe: boolean;
  isCardBackedTrial: boolean;
  isPhone: boolean;
  resumeLoading: boolean;
  onResumeSubscription: () => void;
  t: Translate;
}

/** Scheduled-cancellation (with resume) and pending-plan-change banners. */
export function SubscriptionNoticeBanners({
  profile,
  shouldResubscribe,
  isCardBackedTrial,
  isPhone,
  resumeLoading,
  onResumeSubscription,
  t,
}: SubscriptionNoticeBannersProps) {
  return (
    <>
      {!shouldResubscribe && profile.subscription.cancel_at_period_end && (
        <View style={[profileWebStyles.warningBanner, isPhone && profileWebStyles.warningBannerPhone]}>
          <MaterialIcons name="warning-amber" size={22} color={reviewDesk.amber} />
          <Text style={profileWebStyles.warningText}>
            {isCardBackedTrial
              ? t('profile.trialSetToEnd')
              : t('profile.cancelAtPeriodEnd')}
          </Text>
          <TouchableOpacity
            testID="resume-subscription-button"
            style={profileWebStyles.warningButton}
            onPress={onResumeSubscription}
            disabled={resumeLoading}
            accessibilityRole="button"
          >
            <Text style={profileWebStyles.warningButtonText}>
              {isCardBackedTrial
                ? t('profile.resumeTrialRenewal')
                : t('profile.resumeSubscription')}
            </Text>
          </TouchableOpacity>
        </View>
      )}
      {profile.subscription.pending_plan_tier && profile.subscription.pending_plan_effective_at && (
        <View style={[profileWebStyles.warningBanner, isPhone && profileWebStyles.warningBannerPhone]}>
          <MaterialIcons name="schedule" size={22} color={reviewDesk.amber} />
          <Text style={profileWebStyles.warningText}>
            {t('profile.pendingPlanChange', {
              plan: planDisplayName(t, profile.subscription.pending_plan_tier),
              date: formatDate(profile.subscription.pending_plan_effective_at),
            })}
          </Text>
        </View>
      )}
    </>
  );
}
